import React from 'react';

import { AsyncProgramPPQModalProps } from '.';
import {
  AsyncProgramPPQModalInitialScreen,
  AsyncProgramPPQModalFirstStep,
  AsyncProgramPPQModalConfirmationStep,
  AsyncProgramPPQModalOptionSelections,
  AsyncProgramPPQModalYouAreNotEligibleStep,
} from './AsyncProgramPPQModalSteps/AsyncProgramPPQModalSteps';
import { QuizIdsEnum } from './constants';

export function parseAsyncProgramPPQModalSteps(
  quizId: QuizIdsEnum,
): AsyncProgramPPQModalProps {
  const questions = quizId
    ? AsyncProgramPPQModalOptionSelections(quizId).map((questionComponent) => ({
        mainContent: questionComponent,
      }))
    : [];

  return {
    initialScreenContent: <AsyncProgramPPQModalInitialScreen quizId={quizId} />,
    steps: [
      {
        mainContent: <AsyncProgramPPQModalFirstStep quizId={quizId} />,
      },
      ...questions,
    ],
    finalScreenContent: (
      <AsyncProgramPPQModalConfirmationStep quizId={quizId} />
    ),
    ineligibleScreenContent: <AsyncProgramPPQModalYouAreNotEligibleStep />,
  };
}
